import { render, staticRenderFns } from "./loanMaster.vue?vue&type=template&id=3b1395ad&scoped=true&lang=html"
import script from "./loanMaster.vue?vue&type=script&lang=js"
export * from "./loanMaster.vue?vue&type=script&lang=js"
import style0 from "./loanMaster.vue?vue&type=style&index=0&id=3b1395ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1395ad",
  null
  
)

export default component.exports